import React from 'react';

/* eslint-disable */
class Contact extends React.Component {

	constructor(props) {
    super(props);
		console.log(props);
		this.initMap = this.initMap.bind(this);
  }

	componentDidMount() {
		window.initMap = this.initMap;
		const script = document.createElement("script");
		script.type = 'text/javascript';
		script.async = true;
		script.defer = true;
		script.src = "https://maps.googleapis.com/maps/api/js?key=AIzaSyCSghjz9ITi_Ed73JePFA1avlopdXPr7ho&libraries=places&callback=initMap";
		document.body.appendChild(script);
	}

	initMap() {
		// Styles a map in night mode.
		var map = new google.maps.Map(document.getElementById('map'), {
			center: {lat: -27.4569592, lng: 153.0402486},
			zoom: 19,
			styles: [
			  {
			    "elementType": "geometry",
			    "stylers": [
			      {
			        "color": "#212121"
			      }
			    ]
			  },
			  {
			    "elementType": "labels.icon",
			    "stylers": [
			      {
			        "visibility": "off"
			      }
			    ]
			  },
			  {
			    "elementType": "labels.text.fill",
			    "stylers": [
			      {
			        "color": "#757575"
			      }
			    ]
			  },
			  {
			    "elementType": "labels.text.stroke",
			    "stylers": [
			      {
			        "color": "#212121"
			      }
			    ]
			  },
			  {
			    "featureType": "administrative",
			    "elementType": "geometry",
			    "stylers": [
			      {
			        "color": "#757575"
			      }
			    ]
			  },
			  {
			    "featureType": "administrative.country",
			    "elementType": "labels.text.fill",
			    "stylers": [
			      {
			        "color": "#9e9e9e"
			      }
			    ]
			  },
			  {
			    "featureType": "administrative.land_parcel",
			    "stylers": [
			      {
			        "visibility": "off"
			      }
			    ]
			  },
			  {
			    "featureType": "administrative.locality",
			    "elementType": "labels.text.fill",
			    "stylers": [
			      {
			        "color": "#bdbdbd"
			      }
			    ]
			  },
			  {
			    "featureType": "administrative.neighborhood",
			    "elementType": "geometry.fill",
			    "stylers": [
			      {
			        "saturation": 15
			      }
			    ]
			  },
			  {
			    "featureType": "poi",
			    "elementType": "labels.text.fill",
			    "stylers": [
			      {
			        "color": "#757575"
			      }
			    ]
			  },
			  {
			    "featureType": "poi.attraction",
			    "stylers": [
			      {
			        "visibility": "off"
			      }
			    ]
			  },
			  {
			    "featureType": "poi.business",
			    "stylers": [
			      {
			        "saturation": -10
			      },
			      {
			        "lightness": 5
			      },
			      {
			        "visibility": "simplified"
			      }
			    ]
			  },
			  {
			    "featureType": "poi.park",
			    "elementType": "geometry",
			    "stylers": [
			      {
			        "color": "#181818"
			      }
			    ]
			  },
			  {
			    "featureType": "poi.park",
			    "elementType": "labels.text.fill",
			    "stylers": [
			      {
			        "color": "#616161"
			      }
			    ]
			  },
			  {
			    "featureType": "poi.park",
			    "elementType": "labels.text.stroke",
			    "stylers": [
			      {
			        "color": "#1b1b1b"
			      }
			    ]
			  },
			  {
			    "featureType": "road",
			    "elementType": "geometry.fill",
			    "stylers": [
			      {
			        "color": "#2c2c2c"
			      }
			    ]
			  },
			  {
			    "featureType": "road",
			    "elementType": "labels.text.fill",
			    "stylers": [
			      {
			        "color": "#8a8a8a"
			      }
			    ]
			  },
			  {
			    "featureType": "road.arterial",
			    "elementType": "geometry",
			    "stylers": [
			      {
			        "color": "#373737"
			      }
			    ]
			  },
			  {
			    "featureType": "road.highway",
			    "elementType": "geometry",
			    "stylers": [
			      {
			        "color": "#3c3c3c"
			      }
			    ]
			  },
			  {
			    "featureType": "road.highway",
			    "elementType": "geometry.fill",
			    "stylers": [
			      {
			        "lightness": -30
			      }
			    ]
			  },
			  {
			    "featureType": "road.highway.controlled_access",
			    "elementType": "geometry",
			    "stylers": [
			      {
			        "color": "#4e4e4e"
			      }
			    ]
			  },
			  {
			    "featureType": "road.local",
			    "elementType": "labels.text.fill",
			    "stylers": [
			      {
			        "color": "#616161"
			      }
			    ]
			  },
			  {
			    "featureType": "transit",
			    "elementType": "labels.text.fill",
			    "stylers": [
			      {
			        "color": "#757575"
			      }
			    ]
			  },
			  {
			    "featureType": "water",
			    "elementType": "geometry",
			    "stylers": [
			      {
			        "color": "#000000"
			      }
			    ]
			  },
			  {
			    "featureType": "water",
			    "elementType": "labels.text.fill",
			    "stylers": [
			      {
			        "color": "#3d3d3d"
			      }
			    ]
			  }
			]
		});

		var infowindow = new google.maps.InfoWindow();
		var service = new google.maps.places.PlacesService(map);

		const contentHTML = '' +
		'<div class="googleMapInfoBox">' +
			'<div class="googleMapInfoBox-title" style="margin-bottom: 6px">Same Same</div>' +
			'<div class="googleMapInfoBox-address">' +
				'<div>Shop AM3 Ada Lane</div>' +
				'<div>46 James Street</div>' +
				'<div>Fortitude Valley QLD 4006</div>' +
				'<div>Australia</div>' +
			'</div>' +
			'<div class="googleMapInfoBox-mapLink" style="margin-top: 6px; margin-bottom: 6px">' +
				'<a href="https://goo.gl/maps/QPLU1u5nG7ynZvHt6" target="_blank">View on Google Maps</a>' +
			'</div>' +
		'</div>' +
		'';

		service.getDetails({
      placeId: 'ChIJ59Qq7fNZkWsRqLNh_9iDiH4'
    }, function(place, status) {
      if (status === google.maps.places.PlacesServiceStatus.OK) {
				infowindow.setContent(contentHTML);
				infowindow.setPosition({lat: -27.4569592, lng: 153.0402486});
				infowindow.open(map, this);
      }
    });
	}

	render() {
		return (
			<div className="main-content-body-inner-container main-content-body-contact">
        <div className="main-content-body-title">
          CONTACT
        </div>
        <div className="main-content-text-container main-content-body-scrollable-box">
					<div className="main-content-column-group">
						<div className="main-content-column-block main-content-half-half-column-block">
							<div className="main-content-text-block">
								It’s easy to find us. Walk past the arched James Street entrance to the Calile Hotel and down Ada Lane. Once you hear the sizzling of woks and hum of happy diners, you’ve arrived. Welcome to Same Same.
							</div>
							<div className="main-content-text-block">
								WE’RE OPEN FOR DINNER MONDAY, TUESDAY, WEDNESDAY, THURSDAY AND LUNCH AND DINNER FRIDAY THROUGH SUNDAY.
							</div>
							<div className="main-content-text-block">
								* sAme sAme will be closed on Monday 13th of April and for lunch on Saturday the 25th of April.
							</div>
							<div className="main-content-text-block">
								<u>PLEASE NOTE LAST LUNCH ORDER IS AT 3:00PM</u>
							</div>
							<div className="main-content-text-block">
								All bookings can be made online, however, should you wish to talk to someone, please call daily between 10:00 am - 5:00pm.
							</div>
							<div className="main-content-text-block">
								We sometimes receive a large volume of phone enquiries, so please bear with us if your call rings out due to the line being busy.
							</div>
							<div className="main-content-text-block">
								<div>Phone: <a href="tel:0731881418">(07) 3188 1418</a></div>
							</div>
							<div className="main-content-text-block">
								<div>Outside these times please email us to make a booking</div>
								<div>E-mail: <a href="mailto:seatme@samesamerestaurant.com.au" style={{ textDecoration: 'underline' }}>seatme@samesamerestaurant.com.au</a></div>
							</div>
						</div>
						<div className="main-content-column-block main-content-half-half-column-block">
							<div id="map" style={{ height: 480 }}></div>
						</div>
					</div>
        </div>
			</div>
		);
	}
}

export default Contact;



// WEBPACK FOOTER //
// ./src/Theme/Contact.jsx